import React, { useState } from 'react'
import ContentView from '../../../../../components/PageView/Content'
import { useAuth } from '../../../../../applications/hooks/UseAuth'
import { useLocation } from 'react-router-dom'
import PlantationService from '../../../services/Plantation'
import MonitoringPlantationForm from './form/MonitoringPlantationForm'
import PlantationContext from '../../utils/PlantationContext'

function PlantationMonitoringContent() {
    const haveAccessTo = useAuth()
    const location = useLocation()
    const dataCode = location.pathname.split('/').pop()
    const plantationService = PlantationService.load()
    const [needLoad, setNeedLoad] = useState(false)
    const [needLoadCode, setNeedLoadCode] = useState(false)
    return (
        <>
            <PlantationContext data={location.state ? location.state : null} setNeedLoadCode={setNeedLoadCode} >
                <ContentView
                    title={`Monitoring`}
                    dataId={dataCode}
                    service={plantationService}
                    needLoad={needLoad}
                    haveAccessTo={haveAccessTo}
                    setNeedLoad={setNeedLoad}
                    needLoadCode={needLoadCode}
                    setNeedLoadCode={setNeedLoadCode}
                    Form={MonitoringPlantationForm}
                />
            </PlantationContext>
        </>
    )
}

export default PlantationMonitoringContent
